<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customerCourse.actions.cancel.title')"
    :info="$t('components.customerCourse.actions.cancel.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('components.customerCourse.actions.cancel.confirmButton'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :loading="loading"
    :portal="portal"
  >
    <o-field-group
      :label="$t('general.sendEmail')"
      :info="$t('components.customerCourse.actions.cancel.sendEmail')"
      class="block mb-6"
      col
      reverse
    >
      <toggle-field v-model="sendEmail" />
    </o-field-group>
  </o-dialog>
</template>

<script>
import { OFieldGroup } from '@/components/elements'
import { ToggleField } from '@/components/fields'

export default {
  components: {
    OFieldGroup,
    ToggleField,
  },
  props: {
    portal: {
      type: String,
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      customerCourse: null,
      sendEmail: false,
    }
  },
  methods: {
    open (customerCourse) {
      this.customerCourse = customerCourse

      this.$refs.dialog.open()
    },
    async confirm () {
      this.$emit('update:loading', true)

      try {
        const response = await this.$api.customerCourse.cancel(this.customerCourse, { sendEmail: this.sendEmail })
        const success = response.success

        if (success) {
          const customerCourse = response.data || this.customerCourse
          const customerName = customerCourse.customer?.displayName || this.customerCourse.customer?.displayName

          this.$emit('success', customerCourse)

          this.$bus.emit.updated('CustomerCourse', customerCourse)

          this.$notification.toast({
            title: this.$t('components.customerCourse.actions.cancel.success'),
            text: this.$t('components.customerCourse.actions.cancel.successInfo', { name: customerName }),
            variant: 'success',
          })

          this.$emit('update:loading', false)

          return true
        }
      } catch (e) {
        console.log(e)
        this.$notification.error(e)
      }

      this.$emit('update:loading', false)
    },
  },
}
</script>
